<template lang="pug">
.d-flex
  .flex-grow-1
    filter-date-range.mr-2(ref="date" :dates.sync="datesFilter" initializeDate)
    filter-time-range.mr-2(ref="timeRange" :filter.sync="timeRangeFilter")
    filter-panel-payment-method.mr-2(:filter.sync="panelPaymentMethodFilter" filterKey="payment_ref_ids" singleSelection title="Panel")
    filter-provider.mr-2(:filter.sync="providerFilter")
    filter-visit-codes.mr-2(:filter.sync="visitCodeFilter")
    filter-treatment-products.mr-2(:filter.sync="treatmentProductFilter")
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterDateRange from '@/components/clinic/reports/filters/FilterDateRange.vue'
import FilterTimeRange from '@/components/clinic/reports/filters/FilterTimeRange.vue'
import FilterProvider from '@/components/clinic/reports/filters/FilterProvider.vue'
import FilterVisitCodes from '@/components/clinic/reports/filters/FilterVisitCodes.vue'
import FilterTreatmentProducts from '@/components/clinic/reports/filters/FilterTreatmentProducts.vue'
import FilterPanelPaymentMethod from '@/components/clinic/reports/filters/FilterPanelPaymentMethod.vue'

export default {
  components: { FilterProvider, FilterTimeRange, FilterDateRange, FilterVisitCodes, FilterTreatmentProducts, FilterPanelPaymentMethod },
  props: ['filters'],
  data: () => ({
    key: 0,
    timeRangeFilter: {},
    providerFilter: {},
    visitCodeFilter: {},
    treatmentProductFilter: {},
    datesFilter: [],
    panelPaymentMethodFilter: {}
  }),
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  computed: {
    allFilters () {
      const filters = []
      if (this.providerFilter.key) {
        filters.push(this.providerFilter)
      }
      if (this.datesFilter.length > 0) {
        filters.push({ key: 'date__gte', value: this.datesFilter[0]})
        filters.push({ key: 'date__lte', value: this.datesFilter[1]})
      }
      if (this.timeRangeFilter.key) {
        filters.push(this.timeRangeFilter)
      }
      if (this.visitCodeFilter.key) {
        filters.push(this.visitCodeFilter)
      }
      if (this.treatmentProductFilter.key) {
        filters.push(this.treatmentProductFilter)
      }
      if (this.panelPaymentMethodFilter.key) {
        filters.push(this.panelPaymentMethodFilter)
      }
      return filters
    }
  },
  methods: {
    resetFilters () {
      this.providerFilter = {}
      this.timeRangeFilter = {}
      this.visitCodeFilter = {}
      this.treatmentProductFilter = {}
      this.panelPaymentMethodFilter = {}
      this.datesFilter = []
      this.$refs.date.clear()
      this.$refs.timeRange.clear()
    },
  }
}
</script>